export const b2bVoluntaryPaymentCreateTranslations = {
  title: 'Create operation',
  button: 'Create',
  steps: {
    1: 'General details',
    2: 'Amounts',
    3: 'Payment',
    4: 'Confirmation',
  },
  actions: {
    success: 'Voluntary payment created',
    failure: 'Failed to create voluntary payment: %{error}',
    restricted: 'A voluntary payment cannot be created on a terminated contract.',
    add_allocation: 'Add an allocation',
  },
  choices: {
    type: {
      voluntary_payment: 'Voluntary payment',
      arbitrage: 'Arbitrage',
    },
    payment_method: {
      regular_bank: 'Bank transfer',
      sepa_direct_debit: 'SEPA Direct Debit',
      sepa_direct_debit_with_account: 'SEPA Direct Debit •• %{last_digits}',
    },
    deductibility: {
      deductible: 'Deductible',
      non_deductible: 'Non-deductible',
    },
  },
  sections: {
    affiliate_information: 'Affiliate information',
    type: 'Type of operation',
    payment: 'Payment method',
    summary_confirmation: 'Summary and confirmation',
    confirmations: 'Confirmations',
    confirm_accuracy: 'I confirm the accuracy of the data',
  },
  fields: {
    b2b_company_id: 'Company ID',
    b2b_employee_id_search: 'Search with Employee ID / Full name / NIR / Registration number',
    saving_plan_id: 'Plan',
    amount: 'Amount',
    instrument: 'Instrument',
    deductibility: 'Deductibility',
    total_invested: 'Total amount',
    total_matching_contribution: 'Total matching contribution amount',
    total_entry_fee_employee: 'Entry fees (employee)',
    total_entry_fee_company: 'Entry fees (company)',
  },
  messages: {
    no_employees_found: 'Employee not found',
    no_plans_terminated_contract:
      'Plans from a terminated contract are not available for a voluntary payment.',
    type_subtitle:
      'Select the type of transaction you want to create, whether it is a one-time or recurring payment.',
    bank_info_line_1: 'Banking information to be provided to the employee:',
    bank_info_beneficiary: 'Beneficiary name: %{name}',
    bank_info_iban: 'IBAN: %{iban}',
    bank_info_bic: 'BIC/SWIFT: %{bic}',
    bank_info_reference: 'Payment reference: %{reference}',
  },
};
